import { SelectOption } from "./SelectOption";

export const standardsRatingOptions: SelectOption[] = [
  {
    key: "DA12",
    value: "DA12",
  },
  {
    key: "EN13215",
    value: "EN13215",
  },
  {
    key: "Custom",
    value: "Custom",
  },
];
